import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, X, ShoppingCart, ArrowRight } from 'lucide-react';
import './Toast.css';

const Toast = ({ message, type = 'success', show, onClose, actionLabel, actionLink }) => {
    const [animation, setAnimation] = useState('');

    const handleClose = useCallback(() => {
        setAnimation('toast-out');
        setTimeout(() => {
            onClose();
        }, 300);
    }, [onClose]);
    useEffect(() => {
        if (show) {
            setAnimation('toast-in');
            const timer = setTimeout(() => {
                handleClose();
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [handleClose, show]);


    if (!show && animation !== 'toast-out') return null;

    return (
        <div className={`ec-toast-wrap ${animation}`}>
            <div className={`ec-toast ${type}`}>
                <div className="ec-toast-icon">
                    {type === 'success' ? <CheckCircle size={24} /> : <ShoppingCart size={24} />}
                </div>
                <div className="ec-toast-content">
                    <p className="ec-toast-msg">{message}</p>
                    {actionLink && (
                        <Link to={actionLink} className="ec-toast-action" onClick={handleClose}>
                            {actionLabel || 'View'} <ArrowRight size={14} />
                        </Link>
                    )}
                </div>
                <button className="ec-toast-close" onClick={handleClose}>
                    <X size={18} />
                </button>
            </div>
        </div>
    );
};

export default Toast;
